module.exports = __webpack_public_path__ + "img/ncsa-logo.d9e2cbb2.png";